import React, { FC } from 'react';
import classes from './classes.module.scss';

interface BadgeProps {
    show?: boolean;
}

const Badge: FC<BadgeProps> = ({ show = true }) => {
  if (!show) return null;

  return (
    <div className={ classes.badgeContainer }>
      <div className={ classes.badge } />
    </div>
  );
};

export default Badge;
